import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientPicker } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientPicker/ClientPicker';
import { useClientSelection } from './hooks/useClientSelection';
export const GetClientModalContentTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientModalContent(param) {
    let { draft, setDraft, testId } = param;
    const { ClientModalContentTestIds: TID } = useMemo(()=>GetClientModalContentTID(testId), [
        testId
    ]);
    const { clients, isLoading, error, onRetry, selectedClientId, onSelectClient, onSelectSample, onCreateClient, onEditClient } = useClientSelection(draft, setDraft);
    return /*#__PURE__*/ _jsx(Box, {
        testId: TID.Root(),
        children: /*#__PURE__*/ _jsx(ClientPicker, {
            testId: TID.ClientPicker(),
            clients: clients,
            isLoading: isLoading,
            error: error,
            onRetry: onRetry,
            selectedClientId: selectedClientId,
            onSelectClient: onSelectClient,
            onSelectSample: onSelectSample,
            onCreateClient: onCreateClient,
            onEditClient: onEditClient,
            dropdownMaxHeight: 240
        })
    });
}
